import { ISplitDropDownMenuOptions } from "@mindmemobile/mm-shared-global";
import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import styled from "styled-components"; 

type IProps = {
  label: string;
  className?: string;
  headerClass?: string;
  onClick: () => void;
  options: ISplitDropDownMenuOptions[];
};

const backgroundColor = "#556BB8";
const borderColor = "#556BB8";
const fontColor = "#ffff";
const borderLeftColor = "#ffff";

const DropDownWrapper = styled.div`
  /* PLEASE DONOT REMOVE ANY COMMENTED CODE, IT MIGHT BE REQUIRED ON COMPLETE WORKING */
  /* .dropdown {
        width: 100px;
        height: auto;
    }
    .btn {
        font-size: 14px;
        padding: 4px 12px;
        background-color: ${backgroundColor};
        border-color: ${borderColor};
        :first-child {
            min-width: 100px;
            color: ${fontColor};
            border-right: 0px;
            height: 30px;
            border-radius: 4px;
        }
        :hover {
            background-color: ${backgroundColor};
        }
        :active {
            background-color: ${backgroundColor};
            border-color: ${borderColor};
            box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        }
        :focus {
            border-left-color: ${borderLeftColor};
            box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
        }
    } */
  .split-dropdown {
    .btn:not(.dropdown-toggle-split) {
      background-color: #556bb8;
      border-color: #556bb8;
      box-shadow: none;
      color: #fff;
      min-width: 123px;
      border-right: 0px !important;
      /* &:active,
            &:focus,
            &:hover {
                background-color: #556bb8;
                border-color: #556bb8;
                box-shadow: none;
                color: #fff;
            } */
    }
    .btn.dropdown-toggle-split {
      border-color: #556bb8;
      background-color: #556bb8;
      color: #fff;
      border-left: 1px solid #fff;
      box-shadow: none;
      /* &:active,
            &:focus,
            &:hover {
                background-color: #556bb8;
                border-color: #556bb8;
                box-shadow: none;
                color: #fff;
                border-left: 1px solid #fff;
            } */
    }
    &.btn-group > .btn.btn-info:not(.btn.dropdown-toggle-split) {
      &:hover,
      &:focus,
      &:active {
        z-index: 0;
      }
    }
    .dropdown-menu {
      transform: translate3d(0px, 40px, 0px) !important;
      img {
        height: 14px !important;
        width: 20px;
        margin-bottom: 4px;
      }
      a.dropdown-item {
        &:active {
          background-color: #aaaaaabf;
        }
      }
    }
  }
`;

const SplitDropDown: React.FC<IProps> = ({
  label,
  onClick,
  options,
  className,
  headerClass,
}) => {
  return (
    <>
      <DropDownWrapper className={`dropdown-wrapper ${headerClass}`}>
        <Dropdown as={ButtonGroup} bsPrefix="split-dropdown">
          <Button variant="info" onClick={() => onClick && onClick()}>
            {label}
          </Button>
          <Dropdown.Toggle split variant="info" id="dropdown-split" />
          <Dropdown.Menu>
            {options &&
              options.map((option, index) => {
                return (
                  <Dropdown.Item
                    key={index}
                    onClick={() =>
                      option?.onClick && option.onClick(option.value)
                    }
                    className={className}
                  >
                    {option?.icon && <img src={option.icon} alt="icon" />}{" "}
                    {option.label}
                  </Dropdown.Item>
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      </DropDownWrapper>
    </>
  );
};

export default SplitDropDown;
